<template>
  <div class="pending-settlement" :class="client === 'iOS' ? 'iosBox' : ''">
    <div class="ps-header-spacer" aria-hidden="true"></div>
    <div class="ps-header-fixed">
      <div class="ps-header-inner">
        <img
          class="ps-back"
          src="../../assets/withdrawal_v2/back2.png"
          alt=""
          @click="goBack"
        />
        <p class="ps-title">{{ $t("guild_pending_settlement_detail") }}</p>
      </div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="!loading">
      <div class="ps-scroll">
        <p class="ps-tip">
          {{ $t("guild_pending_settlement_tip", { s: auditHours }) }}
        </p>

        <div class="ps-summary-card">
          <div class="ps-summary-top">
            <span>{{ $t("guild_pending_settlement_amount") }}</span>
            <img
              class="ps-summary-tips"
              src="../../assets/withdrawal_v2/tips.png"
              alt=""
              @click.stop="openTipsDialog"
            />
          </div>
          <div class="ps-summary-amount">
            <img src="../../assets/withdrawal_v2/$.png" alt="" />
            <span>{{ formatCoin(unsettledCoin) }}</span>
          </div>
        </div>

        <div class="ps-list-box">
          <p class="ps-list-tip">
            {{ $t('guild_pending_settlement_list_tips',{
              n: auditHours
            }) }} <span class="ps-list-link" :class="{ 'is-active': canGoCoinRecord }" @click="goToCoinRecord">{{ $t('guild_pending_settlement_list_tips_btn') }}</span> 
            {{ $t('guild_pending_settlement_list_tips_look') }}
          </p>
          <van-list
            v-model="loadingMore"
            :finished="noMore"
            :finished-text="$t('guild_pending_settlement_last_30_days', { n: auditHours })"
            :immediate-check="false"
            @load="onLoad"
          >
            <div
              v-for="item in list"
              :key="item.id"
              class="ps-record-item"
            >
            <div class="ps-record-avatar">
              <img v-if="item.senderAvatar" :src="item.senderAvatar" alt="" />
              <img v-else src="../../assets/withdrawal_v2/avatar.webp" />
            </div>
              <div class="ps-record-main">
                <div class="ps-record-title">
                  <span>{{ item.title }}</span>
                  <!-- 礼物图片 + 数量 -->
                  <span v-if="item.giftIcon" class="ps-gift-tag">
                    <img :src="item.giftIcon" alt="" />x{{ item.count }}
                  </span>
                </div>
                <p class="ps-record-time">{{ item.createTime }}</p>
              </div>
              <div class="ps-record-right">
                <div class="ps-record-amount">+{{ formatCoin(item.amount) }}</div>
              </div>
            </div>
          </van-list>
          <div v-if="!loading && list.length === 0" class="ps-empty"></div>
        </div>
      </div>
    </van-pull-refresh>

    <div v-if="showTipsDialog" class="ps-tips-mask" @click="closeTipsDialog">
      <div class="ps-tips-dialog" @click.stop>
        <span class="ps-tips-close" @click="closeTipsDialog"></span>
        <h3 class="ps-tips-title">{{ $t("guild_withdrawable_amount_title") }}</h3>
        <div class="ps-tips-content">
          <p>{{ $t("guild_withdrawable_amount_tip1") }}</p>
          <p>{{ $t("guild_withdrawable_amount_tip2", { s: auditHours }) }}</p>
          <p>{{ $t("guild_withdrawable_amount_tip3") }}</p>
        </div>
        <button class="ps-tips-btn" type="button" @click="closeTipsDialog">
          {{ $t("guild_got_it") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VanList from "vant/lib/list";
import VanPullRefresh from "vant/lib/pull-refresh";
import "vant/lib/list/style";
import "vant/lib/pull-refresh/style";
import axios from "axios";

export default {
  name: "pendingSettlement",
  components: {
    VanList,
    VanPullRefresh,
  },
  // 待结算列表数据、分页游标与审核时长配置及跳转提现记录所需的公会信息
  data() {
    return {
      client: "PC",
      auditHours: 48,
      unsettledCoin: 0,
      list: [],
      // 游标分页：lastId 为上一页最后一条 id（0=首次），size 每页条数
      lastId: 0,
      size: 30,
      loading: false,
      loadingMore: false,
      refreshing: false,
      noMore: false,
      showTipsDialog: false,
      guildId: "",
      guildUid: "",
      appealToPlatformUrl: "",
      token: "",
      uid: "",
      deviceId: "",
      lang: "",
    };
  },
  // 初始化：读取路由待结算金额/审核时长与公会信息、初始化语言与客户端类型、设置标题
  created() {
    // 从路由读取公会 id / 公会长 uid / 申诉平台链接，供跳转提现记录时透传
    this.guildId = this.$route.query.guildId;
    this.guildUid = this.$route.query.guildUid;
    this.appealToPlatformUrl = this.$route.query.toUrl || "";
    this.initAuth();
    this.initLang();
    this.judgeClient();
    document.title = this.$t("guild_pending_settlement_detail");
  },
  // 挂载后加载第一页数据
  mounted() {
    this.onLoad();
  },
  computed: {
    // 金币记录按钮是否可点：需在 App 内且版本 >= 2.12.0
    canGoCoinRecord() {
      return !!this.getAppVersion() && this.isVersionEnough("2.12.0");
    },
  },
  methods: {
    // 初始化登录态：从 localStorage.data 读取 token / uid / lang / deviceId，供接口请求鉴权
    initAuth() {
      const raw = localStorage.getItem("data");
      if (!raw) return;
      try {
        const data = JSON.parse(raw);
        this.token = data.token;
        this.uid = String(data.uid ?? data.userId ?? "");
        this.lang = data.lang || navigator.language;
        this.deviceId = data.deviceId || "";
      } catch (e) {
        /* ignore */
      }
    },
    // 初始化 i18n 语言：将浏览器语言映射到支持的语言码并同步 html lang
    initLang() {
      const raw = localStorage.getItem("data");
      if (!raw) return;
      try {
        const data = JSON.parse(raw);
        const lang = data.lang || navigator.language;
        const langs = lang.substring(0, 2);
        if (langs === "zh") {
          this.$i18n.locale =
            lang === "zh-TW" || lang === "zh-HK" ? "tc" : "zh";
        } else if (langs === "en") {
          this.$i18n.locale = "en";
        } else if (langs === "ar") {
          this.$i18n.locale = "ar";
        } else if (langs === "tr") {
          this.$i18n.locale = "tr";
        } else if (langs === "es") {
          this.$i18n.locale = "es";
        } else if (langs === "pt") {
          this.$i18n.locale = "pt";
        } else if (langs === "fr") {
          this.$i18n.locale = "fr";
        } else if (langs === "id") {
          this.$i18n.locale = "id";
        } else if (langs === "ms") {
          this.$i18n.locale = "ms";
        } else {
          this.$i18n.locale = "en";
        }
        document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        
      } catch (e) {
        /* ignore */
      }
    },
    // 判断当前平台类型：iOS / Android / PC
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        this.client = "iOS";
      } else if (/(Android)/i.test(navigator.userAgent)) {
        this.client = "Android";
      } else {
        this.client = "PC";
      }
    },
    // 获取当前 App 版本号（仅从 UA 中解析），不在 App 内则返回 null
    getAppVersion() {
      const ua = navigator.userAgent;
      const match = ua.match(/app\/[^:\s]+:(\d+(?:\.\d+)+)/);
      return match ? match[1] : null;
    },
    // 版本号字符串转数字数组，便于逐段比较
    parseVersion(version) {
      const parts = String(version || "").split(".");
      return [
        parseInt(parts[0], 10) || 0,
        parseInt(parts[1], 10) || 0,
        parseInt(parts[2], 10) || 0,
      ];
    },
    // 判断当前 App 版本是否 >= minVersion
    isVersionEnough(minVersion) {
      const cur = this.parseVersion(this.getAppVersion());
      const min = this.parseVersion(minVersion);
      for (let i = 0; i < 3; i++) {
        if ((cur[i] || 0) > (min[i] || 0)) return true;
        if ((cur[i] || 0) < (min[i] || 0)) return false;
      }
      return true;
    },
    // 跳转金币记录：需在 App 内且版本 >= 2.12.0 才可点击；否则无反应
    goToCoinRecord() {
      if (!this.canGoCoinRecord) return;
      const payload = "pushCoinRecord?type=0"; // 具体值需 App 端确认
      if (this.client === "iOS") {
        window.webkit.messageHandlers.pushBannerLink.postMessage(payload);
      } else {
        nativeJs.pushBannerLink(payload);
      }
    },
    // 金额千分位格式化
    formatCoin(val) {
      return Number(val || 0).toLocaleString("en-US");
    },
    // 章样式：1 已结算 / 2 已使用 / 3 已扣除
    stampClass(status) {
      if (status === 1) return "ps-stamp-settled";
      if (status === 2) return "ps-stamp-used";
      if (status === 3) return "ps-stamp-deducted";
      return "";
    },
    // 章文案映射
    stampText(status) {
      if (status === 1) return this.$t("guild_pending_stamp_settled");
      if (status === 2) return this.$t("guild_pending_stamp_used");
      if (status === 3) return this.$t("guild_pending_stamp_deducted");
      return "";
    },
    // 返回：无上一页时关闭 webview，否则路由返回
    goBack() {
      if (window.history.length <= 1) {
        this.$completes.complete("getPreviousPage");
      } else {
        this.$router.go(-1);
      }
    },
    // 打开可提现说明弹窗
    openTipsDialog() {
      this.showTipsDialog = true;
    },
    // 关闭可提现说明弹窗
    closeTipsDialog() {
      this.showTipsDialog = false;
    },
    // 下拉刷新：重置游标并从第一页重新加载
    onRefresh() {
      this.lastId = 0;
      this.noMore = false;
      this.list = [];
      this.loadData(true).finally(() => {
        this.refreshing = false;
      });
    },
    // 上拉加载更多（van-list 触发，首屏列表为空时加载）
    onLoad() {
      if (this.noMore) {
        this.loadingMore = false;
        return;
      }
      this.loadData(this.list.length === 0);
    },
    // 分页加载数据（真实接口）：游标分页（lastId），settleHours 覆盖审核时长
    loadData(isFirst) {
      if (isFirst) {
        this.loading = true;
      }
      return axios({
        url: this.$serviceIp + "api/trade/guild/withdraw/settling/detail",
        method: "get",
        headers: { deviceId: this.deviceId, lang: this.lang, version: "3.0" },
        params: { size: this.size, lastId: this.lastId, token: this.token, uid: this.uid },
      })
        .then((res) => {
          if (res.data.code !== 200) return;
          const data = res.data.data || {};
          // 审核最晚小时数（接口 settleHours 覆盖默认）
          if (data.settleHours) {
            this.auditHours = data.settleHours;
          }
          // 待结算金额（接口 settlingCoin 覆盖默认）
          if (data.settlingCoin !== undefined && data.settlingCoin !== null) {
            this.unsettledCoin = Number(data.settlingCoin) || 0;
          }
          const newList = (data.list || []).map((item) => ({
            id: item.id,
            // 收入类型名直接作标题展示
            title: item.businessTypeName,
            // P币展示值（后端已换算 /10000）
            amount: item.amount,
            // 收入时间（毫秒）→ 格式化展示
            createTime: this.formatTime(item.createTime),
            // 礼物图片 / 数量 / 发送者头像
            giftIcon: item.giftIcon || "",
            count: item.count || 0,
            senderAvatar: item.senderAvatar || "",
          }));
          // 游标分页：lastId===0 为首页替换，否则翻页追加
          if (this.lastId === 0) {
            this.list = newList;
          } else {
            this.list = this.list.concat(newList);
          }
          // 返回条数不足或为空则结束分页，否则用最后一条 id 作为下一页游标
          if (!newList.length || newList.length < this.size) {
            this.noMore = true;
          } else {
            this.lastId = newList[newList.length - 1].id;
          }
        })
        .finally(() => {
          this.loading = false;
          this.loadingMore = false;
        });
    },
    // 格式化收入时间：毫秒时间戳 → "YYYY-MM-DD HH:mm"
    formatTime(ts) {
      if (!ts) return "";
      const d = new Date(Number(ts));
      const pad = (n) => String(n).padStart(2, "0");
      return (
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}`
      );
    },
  },
};
</script>

<style scoped>
.pending-settlement {
  min-height: 100vh;
  background: #f5f6f8;
  font-family: "Mada", sans-serif;
}

.ps-header-spacer {
  height: calc(88px + env(safe-area-inset-top));
  height: calc(88px + constant(safe-area-inset-top));
}

.ps-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
  background: #f5f6f8;
}

.ps-header-inner {
  position: relative;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
}

.ps-back {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 64px;
  height:64px;
}

.ps-title {
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  color: #262427;
}

.ps-scroll {
  min-height: calc(100vh - 88px);
}

.ps-tip {
  margin: 0;
  padding: 8px 28px 24px;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  color: #89848d;
}

.ps-summary-card {
  margin: 0 28px 24px;
  padding: 16px 40px;
  background: #fff;
  border-radius: 24px;
}

.ps-summary-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ps-summary-top span {
  font-size: 20px;
  color: #262427;
  font-weight: 400;
}

.ps-summary-tips {
  width: 24px;
  height: 24px;
}

.ps-summary-amount {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.ps-summary-amount img {
  width: 52px;
  height: 52px;
  margin-right: 8px;
}

.ps-summary-amount span {
  font-size: 48px;
  font-weight: 700;
  color: #262427;
}

.ps-list-box {
  /* margin-top: 8px; */
  background: #fff;
  border-radius: 24px 24px 0 0;
  min-height: calc(100vh - 320px);
  padding: 24px 32px 0;
  
}
.ps-list-tip{
  font-size: 20px;
  font-weight: 400;
  color: #afa9b4;
  text-align: center;
  margin-bottom: 24px;
}
/* 金币记录按钮：仅版本符合(在App内且>=2.12.0)才高亮显示 */
.ps-list-tip /deep/ span.ps-list-link.is-active{
    font-weight: 500;
    color: #8131e7;
    border-bottom: 1px solid #8131e7;
  }
.ps-record-item {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 32px;
  position: relative;
}

.ps-record-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: #ececf0;
  flex-shrink: 0;
  overflow: hidden;
}

.ps-record-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ps-record-main {
  flex: 1;
  min-width: 0;
  margin: 0 16px;
}

.ps-record-title {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  color: #262427;
}

.ps-gift-tag {
  display: flex;
  align-items: center;
  margin-left: 8px;
  font-size: 20px;
  height: 32px;
  box-sizing: border-box;
  border-radius: 16px;
  padding: 2px 8px;
  background-color: #EDEFF2;
}

.ps-gift-tag img {
  width: 28px;
  height: 28px;
  margin-right: 4px;
  display: inline-block;
  object-fit: contain;
}

.ps-record-time {
  margin: 12px 0 0;
  font-size: 24px;
  line-height: 28px;
  font-weight: 400;
  color: #89848d;
}

.ps-record-right {
  position: relative;
  flex-shrink: 0;
  min-width: 120px;
  text-align: right;
}

.ps-record-amount {
  font-size: 24px;
  font-weight: 400;
  color: #262427;
  padding-left: 40px;
  display: flex;
  justify-content: end;
  gap: 8px;
  align-items: center;
}
.ps-record-amount:before{
  content:'';
    width:36px;
    height: 36px;
    background: url("../../assets/withdrawal_v2/$.png") no-repeat left center;
    background-size: 36px 36px;
}

.ps-stamp {
  position: absolute;
  right: 132px;
  top: 50%;
  transform: translateY(-50%);
  min-width: 68px;
  height: 64px;
  background: url('../../assets/withdrawal_v2/seal.png') no-repeat center center;
  background-size: 68px 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  padding: 8px;
  text-align: center;
  pointer-events: none;
}
.ps-stamp span{
  background-color: #fff;
}
.ps-stamp-settled {
  color: #BF1E2E;
}

.ps-stamp-used {
  color: #BF1E2E;
}

.ps-stamp-deducted {
  color: #BF1E2E;
}

.ps-empty {
  width: 240px;
  height: 240px;
  margin: 80px auto;
  background: url("../../assets/withdrawal/null.png") no-repeat center;
  background-size: contain;
}

.ps-tips-mask {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 48px;
}

.ps-tips-dialog {
  position: relative;
  width: 100%;
  max-width: 590px;
  background: #fff;
  border-radius: 24px;
  padding: 48px 40px 40px;
}

.ps-tips-close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.ps-tips-close::before,
.ps-tips-close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background: #121212;
}

.ps-tips-close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.ps-tips-close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.ps-tips-title {
  margin: 0 0 24px;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #121212;
}

.ps-tips-content {
  font-size: 24px;
  line-height: 36px;
  color: #262427;
}

.ps-tips-content p {
  margin: 0 0 16px;
}

.ps-tips-btn {
  display: block;
  width: 100%;
  height: 88px;
  margin-top: 40px;
  border: none;
  border-radius: 44px;
  background: linear-gradient(90deg, #7b4dff 0%, #9b6dff 100%);
  font-size: 28px;
  font-weight: 600;
  color: #fff;
}

html[lang="ar"] .pending-settlement {
  direction: rtl;
}

html[lang="ar"] .ps-back {
  left: auto;
  right: 28px;
  transform: translateY(-50%) rotateY(180deg);
}

html[lang="ar"] .ps-record-amount {
  padding-left: 0;
  padding-right: 40px;
  background-position: right center;
  text-align: right;
}

html[lang="ar"] .ps-stamp {
  right: auto;
  left: 132px;
}
html[lang="ar"] .ps-gift-tag{
  margin-left: 0;
  margin-right: 8px;
}
html[lang="ar"] .ps-gift-tag img{
  margin-right: 0;
  margin-left: 4px;
}
:deep(.van-list__finished-text){
  line-height: 30px;
}
</style>
